import axios from "./axios";

class CommonService {
  getAllCountries() {
    return axios.get("/api/country");
  }

  getAllCurrencies() {
    return axios.get("/api/currency");
  }

  getAllPortCodes() {
    return axios.get("/api/port/list/all");
  }

  getPaymentTerms() {
    return axios.get("/api/org/paymentTerms");
  }

  getAllContainerLoadTypes() {
    return axios.get("/api/container/loadtype/list/all");
  }

  getAllContainerDeliveryMethods() {
    return axios.get("/api/container/containerDeliveryMethods");
  }
}

export default new CommonService();